import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GridFilter, PagingDataResult, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { DialogType } from "../../../../../../projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { FinanceNotificationHeader } from "../../models/finance-notification-header.model";
import { HRNotificationHeader } from "../../models/hrnotification-header.model";
import { FinanceNotificationHeaderFormComponent } from "../finance-notification-header-form/finance-notification-header-form.component";

@Component({
  selector: "ngx-finance-notification-header-list",
  templateUrl: "./finance-notification-header-list.component.html",
  styleUrls: ["./finance-notification-header-list.component.scss"],
})
export class FinanceNotificationHeaderListComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  editingName: { name: string };
  HRNtificationItemColumns: form_control[] = [];
  _HRNtificationItems: FinanceNotificationHeader[];
  selectedRow: FinanceNotificationHeader;
  hRNotificationHeader: HRNotificationHeader;
  get HRNtificationItems() {
    return this._HRNtificationItems;
  }
  constructor() {
    super();
    this.inputEditorform = FinanceNotificationHeaderFormComponent;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.inputEditorform = undefined;
    this.editingName = undefined;
    this.HRNtificationItemColumns = undefined;
    this._HRNtificationItems = undefined;
    this.selectedRow = undefined;
    this.hRNotificationHeader = undefined;
  }
  ngOnInit() {
    this.apiName = "HRNotificationHeader/HRNotifications";
    this.areaName = "Payroll";
    this.label = "احکام مالی";
    this.setDetailColumns();
  }
  setDetailColumns() {
    this.httpCommonService
      .getControlsList("FinanceNotificationHeader")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.HRNtificationItemColumns = data as form_control[];
            this.HRNtificationItemColumns.forEach((x) => {
              if (x.name === "PersCode" || x.name === "FullName" || x.name === "CertificateID") {
                x.listVisible = false;
              }
            });
            this.HRNtificationItemColumns = this.HRNtificationItemColumns.sort((a, b) => a.order - b.order);
          }
        },
        (error) => console.log(error)
      );
  }
  onEdit(event: FinanceNotificationHeader) {
    if (!event && !this.selectedRow) {
      this.sts.showDialog(`هیچ کارمندی انتخاب نشده است.`, "پیغام خطا");
    } else if (this.HRNtificationItems && this.HRNtificationItems.length > 0) {
      this._HRNtificationItems = this.HRNtificationItems.sort((a, b) => b.Id - a.Id);
      event = this.HRNtificationItems[0];
    } else if (!event && this.selectedRow) event = this.selectedRow;
    event.State = RowState.Modify;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: event,
          apiName: this.apiName,
          areaName: this.areaName,
          label: this.label,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        setTimeout(() => this.onDoubleClick(model as HRNotificationHeader), 200);
      });
  }
  onCreate(event: FinanceNotificationHeader) {
    if (!event && !this.hRNotificationHeader && (!this.HRNtificationItems || this.HRNtificationItems.length <= 0)) {
      this.sts.showDialog(`هیچ کارمندی انتخاب نشده است.`, "پیغام خطا");
    } else if (this.HRNtificationItems && this.HRNtificationItems.length > 0) {
      this._HRNtificationItems = this.HRNtificationItems.sort((a, b) => b.Id - a.Id);
      event = this.HRNtificationItems[0];
    } else if (!event && this.hRNotificationHeader) event = new FinanceNotificationHeader();
    event.HrmPersonnelId = this.hRNotificationHeader.HrmPersonnelId;
    event.State = RowState.New;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: event,
          apiName: this.apiName,
          areaName: this.areaName,
          label: this.label,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        setTimeout(() => this.onDoubleClick(model as HRNotificationHeader), 200);
      });
  }
  onDelete(event: FinanceNotificationHeader) {
    this.sts.showDialog(`آیا از حذف اطلاعات اطمینان دارید؟`, "حذف اطلاعات", DialogType.confirm, () => this.deleteFormHelper(event));
  }
  deleteFormHelper(row: any) {
    this.sts.showToast("primary", "", "در حال حذف...");
    this.httpCommonService
      .delete("FinanceNotificationHeader/DeleteItem", row.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (results) => {
          this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
        }
      );
  }
  onDoubleClick(hRNotificationHeader: HRNotificationHeader) {
    this.hRNotificationHeader = hRNotificationHeader;
    var filters: GridFilter[] = [];
    filters.push({ Filed: "HrmPersonnelId", Value: hRNotificationHeader.HrmPersonnelId, Operator: "eq", Type: "F", Skip: 0, Take: 0 });
    this.httpCommonService
      .GetFilterGrid<PagingDataResult<FinanceNotificationHeader>>("FinanceNotificationHeader/GetFilterGrid", filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: PagingDataResult<FinanceNotificationHeader>) => {
          if (data) {
            this._HRNtificationItems = data.Data.sort((a, b) => b.Id - a.Id);
            this.selectedRow = this._HRNtificationItems[0];
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
